import React, { useState } from "react";
import { useQuery, useMutation } from "@apollo/client";
import { Layout, Table } from "antd";
import Header from "../../Components/Header";
import { DELETE_ACCOUNTPLANS, GET_ACCOUNTPLANS } from "./Requests";
import Footer from "../../Components/Footer";
import {
  getContentRows,
  getContentColumns,
  checkIfNextDisabled
} from "./Utility/TableUtility";
import "../../UI/CommonStyles.less";
import Actions from "../../Components/Actions";
import CreateAccountPlan from "./CreateAccountPlan";
import EditAccountPlan from "./EditAccountPlan";
import { useTranslation } from "react-i18next";
import DeleteModal from "../../Components/DeleteModal";

const { Content } = Layout;

const AccountPlans = ({ history }) => {
  const { t } = useTranslation();
  const [page, setPage] = useState(1);
  const [number, setNumber] = useState(20);
  const [idClicked, setIdClicked] = useState(undefined);
  const [showDeleteModal, setDeleteModal] = useState(false);
  const [createModal, setCreateModal] = useState(false);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [deleteAccountPlansByAdmin] = useMutation(DELETE_ACCOUNTPLANS);
  const { data, refetch } = useQuery(GET_ACCOUNTPLANS);

  const rowSelection = {
    selectedRowKeys,
    onChange: setSelectedRowKeys
  };

  const handleDelete = async () => {
    await deleteAccountPlansByAdmin({
      variables: {
        ids: selectedRowKeys,
      },
      update: (cache, res) => {}
    }).catch((error) => {
      alert(error);
    });
    refetch();
    setSelectedRowKeys([]);
  };

  const rowIdClicked = (record) => {
    return {
      onClick: () => {
        setIdClicked(record.id);
      }
    };
  };

  const beforeCloseDeleteModal = () => {
    setDeleteModal(false);
    setSelectedRowKeys([]);
  }

  const beforeConfirmDeleteModal = () => {
    setDeleteModal(false);
    setSelectedRowKeys([]);
    handleDelete();
  }

  return (
    <Layout className="pageContainer">
      {idClicked !== undefined && (
        <EditAccountPlan
          refetch={refetch}
          history={history}
          onClose={() => setIdClicked(undefined)}
          id={idClicked}
        />
      )}
      {createModal && (
        <CreateAccountPlan
          refetch={refetch}
          onClose={() => setCreateModal(false)}
        />
      )}

      <Header canShowFilters={false} name={t("ACCOUNT PLANS")}/>
      <Content className="card">
        <Actions
          add={() => setCreateModal(true)}
          deletePicked={() => setDeleteModal(true)}
          disableDelete={!selectedRowKeys.length}
        />
        <Table
          pagination={false}
          rowSelection={rowSelection}
          dataSource={getContentRows(data, t)}
          columns={getContentColumns(t)}
          onRow={rowIdClicked}
          footer={() => (
            <Footer
              page={page}
              setNumber={setNumber}
              setPage={setPage}
              nextDisable={checkIfNextDisabled(data, number)}
            />
          )}
        />
      </Content>
      <DeleteModal
        show={showDeleteModal}
        onClose={beforeCloseDeleteModal}
        onDelete={beforeConfirmDeleteModal}
      />
    </Layout>
  );
};

export default AccountPlans;
